/**
 * Use Case: Fetch Voucherku Products
 * Business logic for fetching the list of available Voucherku products.
 */

import type { VoucherkuProduct } from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Fetch the list of available Voucherku products
 * @param categoryId - Optional category ID to filter products
 */
export const FetchVoucherkuProductsUseCase = async (
  categoryId?: string
): Promise<readonly VoucherkuProduct[]> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.fetchVoucherkuProducts(categoryId);
};

